import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "flex-row bool-wrapper" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "invalid-input-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-input flex-col", { invalid: _ctx.showError }])
  }, [
    _createElementVNode("label", { for: _ctx.elementName }, _toDisplayString(_ctx.label), 9, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(["si-cb si-input flex-center", { 'si-alt': _ctx.altStyle }]),
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('onClick', !_ctx.value)), ["stop"])),
        disabled: _ctx.disabled ? true : undefined
      }, [
        _withDirectives(_createElementVNode("i", null, _cache[1] || (_cache[1] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            height: "34px",
            viewBox: "0 0 24 24",
            width: "34px",
            fill: "currentColor"
          }, [
            _createElementVNode("path", {
              d: "M0 0h24v24H0V0z",
              fill: "none"
            }),
            _createElementVNode("path", { d: "M9 16.2l-3.5-3.5c-.39-.39-1.01-.39-1.4 0-.39.39-.39 1.01 0 1.4l4.19 4.19c.39.39 1.02.39 1.41 0L20.3 7.7c.39-.39.39-1.01 0-1.4-.39-.39-1.01-.39-1.4 0L9 16.2z" })
          ], -1)
        ]), 512), [
          [_vShow, _ctx.value]
        ])
      ], 10, _hoisted_3),
      _createElementVNode("span", {
        class: "cb-desc",
        innerHTML: _ctx.description
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.errorMsg), 1)
  ], 2))
}